

















































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { EFacilityBlockableFeatures, EUserPermissions, EUserStatus, IChain, IFacility, IPayerType, IUser } from '@zunta/configurations'
import Tabs from '@/components/layout/Tabs.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import Api from '@/api'
import { User } from '@/classes/User'
import { ChainModule } from '@/store/modules/chain.module'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { getSelectContentLabel } from '@/utils/helpers'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'
import { FacilityCompletedLevels } from '@/store/types/facility'
import { getFacilityCompleteLevelObject, getFacilityGeneralInfoCompleteLevel } from '@/utils/facility/facilityLevels'
import { ResidentModule } from '@/store/modules/resident.module'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

@Component({
  components: {
    SelectV2,
    LoaderWrapper,
    Icon,
    Card,
    Tabs,
    StatusFacilityComplete
  }
})
export default class ManagementSettings extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  getSelectContentLabel: Function = getSelectContentLabel
  EUserPermissions = EUserPermissions
  user: User = Api.getUser() as User
  isLoading: boolean = false
  isLoading2: boolean = false
  firstLoad: boolean = true
  facilitiesListOptions: any[] = []
  get selectedFacilityName () {
    if (!this.facility) {
      return ''
    }
    return this.facility.shortName ? this.facility.shortName : this.facility.name
  }

  get facility () {
    return this.$store.state.facility.selectedFacility as IFacility
  }

  get facilityId () {
    return this.$store.state.facility.selectedFacility
      ? this.$store.state.facility.selectedFacility.id
      : -1
  }

  get tabs () {
    const items: any = []

    if (this.user.hasPermissionFor(EUserPermissions.VIEW_USERS)) {
      items.push({
        label: 'Users',
        icon: 'users',
        to: { name: 'management-users' }
      })
    }

    if (this.user.hasPermissionFor(EUserPermissions.VIEW_PERMISSIONS)) {
      items.push({
        label: 'Permissions',
        icon: 'task',
        to: { name: 'management-users-permissions' }
      })
    }

    if (this.user.hasPermissionFor(EUserPermissions.VIEW_TEMPLATES)) {
      items.push({
        label: 'Templates',
        icon: 'template',
        to: { name: 'management-templates' }
      })
    }

    items.push({
      label: `HMOs`,
      icon: 'sheild',
      to: { name: 'management-hmos' }
    })

    return items
  }

  get subTabs () {
    if (!this.user.hasPermissionFor(EUserPermissions.VIEW_FACILITIES)) return []
    return [{
      label: 'General Info',
      to: { name: 'management-facilities-settings-information', params: { id: this.facilityId } },
      completedLevel: this.facilityCompleteLevels.generalInfo
    },
    this.user.hasPermissionFor(EUserPermissions.EDIT_FACILITY_ADVANCED_SETTINGS) && this.isAllowedToSeeBatchSettings && {
      label: 'Batches',
      to: { name: 'management-facilities-settings-batch', params: { id: this.facilityId } },
      completedLevel: this.facilityCompleteLevels.batch
    },
    this.user.hasPermissionFor(EUserPermissions.VIEW_COLLECTIONS_FLOW) && {
      label: 'Collections',
      to: { name: 'management-facilities-settings-collections-management', params: { id: this.facilityId } }
    },
    this.user.hasPermissionFor(EUserPermissions.VIEW_PAYMENT_ACCOUNT_AND_PAY_SETTINGS) && {
      label: 'Payments',
      to: { name: 'management-facilities-settings-payment-settings', params: { id: this.facilityId } }
    },
    this.user.hasPermissionFor(EUserPermissions.MODIFY_PAYER_TYPES) && {
      label: 'Payers',
      to: { name: 'management-facilities-settings-payers', params: { id: this.facilityId } },
      completedLevel: this.facilityCompleteLevels.payers
    },
    this.user.hasPermissionFor(EUserPermissions.VIEW_FACILITY_FEES) && {
      label: 'Billing',
      to: { name: 'management-facility-billing', params: { id: this.facilityId } }
    }].filter(Boolean) as { label: string, to: { name: string, params: { id: number }}, completedLevel: number }[]
  }

  get facilityStatistics () {
    return this.$store.state.facility.statistics
  }

  get isUserEdit () {
    return this.$route.name === 'management-users-edit'
  }

  get userData () {
    return this.userModuleInstance.getUser as IUser
  }

  get chain () {
    return this.chainModuleInstance.getChain || {} as IChain
  }

  get selectedFacilityTooltip () {
    return this.$store.state.facility.facilities2.find((facility: IFacility) => facility.id === this.facilityId)
  }

  get facilityCompleteLevels () {
    return this.$store.state.facility.facilityCompleteLevels as FacilityCompletedLevels
  }

  get users () {
    return this.$store.state.user.users as IUser[]
  }

  get userIds () {
    return this.users
      .filter(user => {
        return (
          user.isAllFacilities ||
          ((user.facilities && user.facilities.includes(this.facilityId)) ||
            (this.facility && this.facility.residentBillingContact === user.id))
        )
      })
      .map(user => user.id)
  }

  get facilitiesActivePayerTypesMap (): { [k: string]: IPayerType[] } {
    return this.$store.state.facility.facilitiesActivePayerTypesMap
  }

  get facilityGeneralCompleteLevel () {
    return getFacilityGeneralInfoCompleteLevel(this.facility, this.userIds)
  }

  get residentTypeOfContactList (): string[] {
    return this.$store.state.resident.typeOfContactList
  }

  async mounted () {
    this.facilityModuleInstance.UPDATE_SELECTED_FACILITY(null)
    this.$eventBus.$on('reload-facility-list', this.loadFacilities)
    this.$watch('$route', (newVal, oldVal) => {
      const facilitiesRoute = { name: 'management-facilities' }
      if (
        oldVal.name !== newVal.name &&
        (newVal.name === facilitiesRoute.name ||
        this.tabs.findIndex((tab: any) => tab.to.name === newVal.name) > -1)
      ) {
        this.facilityModuleInstance.UPDATE_SELECTED_FACILITY(null)
      }

      if (oldVal.name !== newVal.name && oldVal.name === 'management-users') {
        this.reloadUsers()
      }
    })

    const $header: any = document.querySelector('.header-wrapper')
    if ($header) {
      $header.classList.add('sticky-header')
    }

    if (this.$route.query.importFacilities === 'true') {
      this.openPccLogin()
      return
    }

    try {
      this.isLoading = true
      await Promise.all([
        this.facilityModuleInstance.getFacilityList2({}),
        this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
      ])
      this.setFacilitiesOptions()
      if (this.$route.params.id) await this.loadSelectedFacilityData(Number(this.$route.params.id))
    } finally {
      this.isLoading = false
      this.firstLoad = false
    }
  }

  async loadSelectedFacilityData (facilityId: number) {
    if (!facilityId) return
    await this.facilityModuleInstance.getFacility(facilityId)
    await Promise.all([
      this.facilityModuleInstance.fetchFacilitiesActivePayerTypesMap([this.facility.id as number]),
      this.residentModuleInstance.fetchResidentTypeOfContactList(this.facility.id as number)
    ])
    this.facilityModuleInstance.SET_FACILITY_COMPLETE_LEVEL(
      getFacilityCompleteLevelObject({
        facility: this.facility,
        facilitiesActivePayerTypesMap: this.facilitiesActivePayerTypesMap,
        users: this.users,
        contactListType: { [this.facility.id as number]: this.residentTypeOfContactList }
      })
    )
  }

  beforeDestroy () {
    this.$eventBus.$off('reload-facility-list')
    this.facilityModuleInstance.UPDATE_SELECTED_FACILITY(null)
    const $header: any = document.querySelector('.header-wrapper')
    if ($header) {
      $header.classList.remove('sticky-header')
    }
  }

  setFacilitiesOptions () {
    const availableFacilityOption = this.$store.state.facility.facilities2.map((facility: IFacility) => {
      return {
        value: facility.id,
        key: facility.id,
        content: (facility.shortName ? facility.shortName : '') + '' + facility.name,
        name: facility.name,
        shortName: facility.shortName ? facility.shortName : ''
      }
    })

    this.facilitiesListOptions =
      this.user.isAllFacilitiesAvailable()
        ? availableFacilityOption
        : availableFacilityOption.filter((option: any) =>
          this.user.data.facilities && this.user.data.facilities.length
            ? this.user.data.facilities.includes(option.value)
            : false)
  }

  async reloadUsers () {
    try {
      this.isLoading = true
      await this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
    } finally {
      this.isLoading = false
    }
  }

  async loadFacilities () {
    try {
      this.isLoading = true
      await this.facilityModuleInstance.getFacilityList2({})
      this.setFacilitiesOptions()
    } finally {
      this.isLoading = false
    }
  }

  async selectFacility (item: string | number) {
    try {
      this.isLoading = true
      this.isLoading2 = !this.$route.params.id && true
      await this.loadSelectedFacilityData(Number(item))
      const generalInfoPath = 'management-facilities-settings-information'
      const id = item.toString()
      const isNewPath =
        this.$route.params.id !== id ||
        this.$route.name !== generalInfoPath
      if (isNewPath) {
        await this.$router.replace({
          name: generalInfoPath,
          params: {
            id
          }
        })
      }
    } finally {
      window.scrollTo({ top: 0 })
      this.isLoading = false
      this.isLoading2 = false
    }
  }

  openPccLogin () {
    this.$router.push({ name: 'management-facilities-login' })
  }

  get isAllowedToSeeBatchSettings () {
    return !isFacilityFeatureBlocked(this.facility, EFacilityBlockableFeatures.MailAndGenStatements) || this.user.isSystemAdmin()
  }
}
